import axios from 'axios';
import { configRefs } from '@utils/constants';

async function deleteCourseRequest(course) {
  await axios.delete(`${await configRefs.apis.userdata.get()}/api/v2/Courses?id=${encodeURIComponent(course.id)}`);
}

export { deleteCourseRequest };
//# sourceMappingURL=request.delete.js.map
